/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does it keep running if I switch tabs?`)
};

const es_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Sigue funcionando si cambio de pestaña?`)
};

const de_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läuft es weiter, wenn ich den Tab wechsle?`)
};

const nl_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blijft hij lopen als ik van tabblad wissel?`)
};

const fr_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue-t-il si je change d'onglet ?`)
};

const it_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a funzionare se cambio scheda?`)
};

const pt_br2_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela continua rodando se eu trocar de aba?`)
};

const pt_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continua a funcionar se eu mudar de separador?`)
};

const ja_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タブを切り替えても動き続けますか?`)
};

const zh_cd_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换标签页后它还会继续运行吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cd_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cd_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cd_faq_q3", locale)
	if (locale === "en") return en_cd_faq_q3(inputs)
	if (locale === "es") return es_cd_faq_q3(inputs)
	if (locale === "de") return de_cd_faq_q3(inputs)
	if (locale === "nl") return nl_cd_faq_q3(inputs)
	if (locale === "fr") return fr_cd_faq_q3(inputs)
	if (locale === "it") return it_cd_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_cd_faq_q3(inputs)
	if (locale === "pt") return pt_cd_faq_q3(inputs)
	if (locale === "ja") return ja_cd_faq_q3(inputs)
	return zh_cd_faq_q3(inputs)
};